import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getListCompetitor = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_COMPETITOR}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListCompetitorCountry = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_COMPETITOR_COUNTRY_API}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListCompetitorById = async (id) => {
  const api = `${APIEndpoint.GET_LIST_COMPETITOR_ฺBY_ID}` + `/${id}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const searchCompetitorCustomers = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_COMPETITOR_API;
  const payload = {
    requestObject: {
      countryId: searchValues.countryId || "",
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const createCompetitor = async (request) => {
  const api = APIEndpoint.CREATE_COMPETITOR_API;
  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updateCompetitor = async (id, request) => {
  const api = APIEndpoint.UPDATE_COMPETITOR_API + `/${id}`;
  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};
